var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0322 4.9165C3.57344 5.71108 2.42656 5.71108 1.9678 4.9165L0.161459 1.78782C-0.297295 0.993231 0.276148 -8.0211e-08 1.19366 0L4.80634 3.15831e-07C5.72385 3.96042e-07 6.29729 0.993232 5.83854 1.78782L4.0322 4.9165Z",
    fill: "#F4F5F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownClose);
export default __webpack_public_path__ + "static/media/dropdown-close.b1c2e7119692782f10259473dcfdda28.svg";
export { ForwardRef as ReactComponent };